import isValid from 'date-fns/isValid'
import toDate from 'date-fns/toDate'

export default function _intervalToDuration(start: Date | number, end: Date | number) {

  if (!isValid(toDate(start))) {
    throw new RangeError('Start Date is invalid')
  }
  if (!isValid(toDate(end))) {
    throw new RangeError('End Date is invalid')
  }

  const SECOND = 1000
  const MINUTE = 60 * SECOND
  const HOUR = 60 * MINUTE
  const DAY = 24 * HOUR

  const startTime: number = start instanceof Date ? start.getTime() : start
  const endTime: number = end instanceof Date ? end.getTime() : end
  const difference = Math.abs( endTime - startTime )

  const duration = {
    days: Math.floor( difference / DAY),
    hours: Math.floor((difference % DAY ) / HOUR),
    minutes: Math.floor((difference % HOUR ) / MINUTE),
    seconds: Math.floor((difference % MINUTE ) / SECOND)
  }

  return duration
}
